export const getToken = key => localStorage.getItem(key)

const setStorageItem = ({name, data}) => localStorage.setItem(name, data)

export const setToken = token => setStorageItem({name: 'authToken', data: token})

export const removeToken = key => localStorage.removeItem(key)

export const setTrustToken = token => setStorageItem({name: 'trustToken', data: token})

export const setRefreshToken = token => setStorageItem({name: 'refreshToken', data: token})

/**
 * Refresh spends the token it is given and returns a replacement, so a response stored only in part
 * leaves the session unable to refresh a second time. Every endpoint that issues tokens goes
 * through here.
 */
export const setSessionTokens = ({authToken, refreshToken, trustToken}) => {
  if (authToken)
    setToken(authToken)

  if (refreshToken)
    setRefreshToken(refreshToken)

  if (trustToken)
    setTrustToken(trustToken)
}

/**
 * The mirror of `setSessionTokens`. Signing out revokes the auth token alone, so a refresh token
 * left in storage is still a whole session, and the next visit to a gated route spends it to sign
 * the account back in. The trust token is the device's, not the session's, and outlives both.
 */
export const clearSessionTokens = () => {
  removeToken('authToken')
  removeToken('refreshToken')
}
